import React from "react";
import { AlertTriangle, X } from "lucide-react";
import "../styling/confirmationBox.css";

const ConfirmDialog = ({
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="confirm-overlay">
      <div className="confirm-box">
        <button className="confirm-close" onClick={onCancel}>
          <X size={18} />
        </button>

        <div className="confirm-icon">
          <AlertTriangle size={28} />
        </div>

        <h3 className="confirm-title">{title}</h3>
        <p className="confirm-message">{message}</p>

        <div className="confirm-actions">
          <button className="btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
